import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/lib/stores/store';
import { DEFAULT_CHAIN_ID } from '@/lib/config/chain';
type WithdrawTokenInfo = {
  chainId?: number;
  tokenAddress?: string;
  amount?: string;
  tokenName?: string;
  minWithdrawAmount?: string;
};

type AccountState = {
  name: string;
  refreshBalance: boolean;
  refreshLimitOrder: boolean;
  refreshTradeHistory: boolean;
  refreshHoldingHistory: boolean;
  withdrawTokenInfo: WithdrawTokenInfo;
  currentChainId: string;
  omniMode?: boolean;
};
const accountInitState: AccountState = {
  name: '',
  refreshBalance: false,
  refreshLimitOrder: false,
  refreshTradeHistory: false,
  refreshHoldingHistory: false,
  withdrawTokenInfo: {
    chainId: 0,
    tokenAddress: '',
    amount: '',
    tokenName: '',
    minWithdrawAmount: '',
  },
  currentChainId: DEFAULT_CHAIN_ID,
  omniMode: undefined,
};
const accountSlice = createSlice({
  name: 'account',
  initialState: accountInitState,
  reducers: {
    setName: (state, action) => {
      state.name = action.payload;
    },
    setRefreshBalance: (state, action: PayloadAction<boolean>) => {
      state.refreshBalance = action.payload;
    },
    setRefreshLimitOrder: (state, action: PayloadAction<boolean>) => {
      state.refreshLimitOrder = action.payload;
    },
    setRefreshTradeHistory: (state, action: PayloadAction<boolean>) => {
      state.refreshTradeHistory = action.payload;
    },
    setRefreshHoldingHistory: (state, action: PayloadAction<boolean>) => {
      state.refreshHoldingHistory = action.payload;
    },
    setWithdrawTokenInfo: (state, action: PayloadAction<WithdrawTokenInfo>) => {
      state.withdrawTokenInfo = action.payload;
    },
    setCurrentChainId: (state, action: PayloadAction<string>) => {
      state.currentChainId = action.payload;
    },
    setOmniMode: (state, action: PayloadAction<boolean>) => {
      state.omniMode = action.payload;
    },
  },
});
export const reduxAccountName = (state: RootState) => state.account.name;
export const reduxRefreshBalance = (state: RootState) =>
  state.account.refreshBalance;
export const reduxRefreshLimitOrder = (state: RootState) =>
  state.account.refreshLimitOrder;
export const reduxRefreshTradeHistory = (state: RootState) =>
  state.account.refreshTradeHistory;
export const reduxRefreshHoldingHistory = (state: RootState) =>
  state.account.refreshHoldingHistory;
export const reduxWithdrawTokenInfo = (state: RootState) =>
  state.account.withdrawTokenInfo;
export const reduxCurrentChainId = (state: RootState) =>
  state.account.currentChainId;
export const reduxOmniMode = (state: RootState) => state.account.omniMode;

export const {
  setName,
  setRefreshBalance,
  setRefreshLimitOrder,
  setRefreshTradeHistory,
  setRefreshHoldingHistory,
  setWithdrawTokenInfo,
  setCurrentChainId,
  setOmniMode,
} = accountSlice.actions;
export default accountSlice.reducer;
